var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-with__description",class:{ new: _vm.$route.meta.isNews }},[_c('h2',{staticClass:"title-with__description-title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"title-with__description-description",class:{ positionCenter: _vm.positionCenter },domProps:{"innerHTML":_vm._s(_vm.info.description)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }